module.exports = __webpack_public_path__ + "media/images/fb-5f34e32daa6bba8e0ce5af4d45683797.svg";